import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {  IncidentOwnerMappingDto, AssetLocationDto, IdentityUserDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-incident-owners-mapping',
  templateUrl: './incident-owners-mapping.component.html',
  styleUrls: ['./incident-owners-mapping.component.scss']
})
export class IncidentOwnersMappingComponent implements OnChanges {

  incidentOwnersForm: FormGroup;
  incidentOwnersFormArray: FormGroup;
  control = new FormControl();
  @Input() incidentOwnersMappings: IncidentOwnerMappingDto[] = [];
  @Input() assetLocations: AssetLocationDto[] = [];
  @Input() owners: IdentityUserDto[] = [];
  @Input() routeAnimationsElements: any;
  @Output() incidentOwnersMapping = new EventEmitter<IncidentOwnerMappingDto[]>()
  @Output() deleteIncidentOwnersMappingEvent = new EventEmitter<any>()
  
 
  filteredDelete: Array<any> =[];
  loading = true;
  selectedIndex = null;
  StaffName: string;
  AssetLocationName: string;
  status: boolean;
  // filteredIncidenceOwnerList: Array<any> = [];
  constructor(
   private fb: FormBuilder,
   ) {}

  ngOnChanges() {
    this.createIncidentOwnerMappingForm();

  }

  createIncidentOwnerMappingForm() {
    this.incidentOwnersForm = this.fb.group({      
      AssetLocationId: [''],
      AssetLocationName: [''],
      StaffId: [''],
      StaffName: [''],
      id: null
      });
      this.incidentOwnersFormArray = this.fb.group({ IncidentOwnerMappings: this.fb.array([])
        });
      this.setIncidentOwners();
  }

  setIncidentOwners() {
    const control  = this.incidentOwnersFormArray.controls.IncidentOwnerMappings as FormArray;
    this.incidentOwnersMappings.forEach( e => {
      control.push(
        this.fb.group({
          AssetLocationId: e.AssetLocationId,
          AssetLocationName: e.AssetLocationName,
          StaffId: e.StaffId,
          StaffName: e.StaffName,
          id: e.id
        })
      );
    });
  }

  onSelectLocations(id: string) {
    this.AssetLocationName = this.assetLocations.find(asset => asset.id === id)?.AssetLocationAddress || null;

  }
  onSelectOwners(id: string) {
    this.StaffName = this.owners.find(owner => owner.Id === id)?.StaffName || null;

  }
   // method to add IncidentOwnerMapping
   addIncidentOwners(value: IncidentOwnerMappingDto) {
    const control  = this.incidentOwnersFormArray.controls.IncidentOwnerMappings as FormArray;
    control.insert(0,
          this.fb.group({
            AssetLocationId: value.AssetLocationId,
            AssetLocationName: this.AssetLocationName,
            StaffId: value.StaffId,
            StaffName: this.StaffName,
            id: null
          })
       );
  }

  getAssetLocationName(id: string) {

    if(this.assetLocations != null){

      const found = this.assetLocations.find(asset => asset.id === id);
      return found ? found.AssetLocationAddress : '';
    }
   
  }

  getStaffName(id: string) {
    const found = this.owners.find(owner => owner.Id === id);
   return found ? found.StaffName : '';
  }
  deleteIncidentOwnersMapping(index, value) {
    console.log("Checking Ids...", value);
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.incidentOwnersFormArray.controls.IncidentOwnerMappings as FormArray;
  control.removeAt(index);
  if (value.id !== null)
  {
    this.filteredDelete.push(value.id);
  }
 
 
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: IncidentOwnerMappingDto) {
    if(this.incidentOwnersForm.invalid) {
    Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    return;
    }
   
    if(this.selectedIndex != null) {

    

      this.incidentOwnersFormArray.get('IncidentOwnerMappings')['controls'][this.selectedIndex].patchValue({ ...formValue});
    console.log("The selected...", formValue);
       
    } else {
      this.addIncidentOwners(formValue);
    }
    this.selectedIndex = null;
    this.incidentOwnersForm.reset()
  }

  onEdit(index, value: IncidentOwnerMappingDto) {
    this.selectedIndex = index;
    this.incidentOwnersForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.incidentOwnersForm.reset();
  }
  clearFormArray = (formArray: FormArray) => {
    const control = this.incidentOwnersFormArray.controls.IncidentOwnerMappings as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

 
  // onSubmit(formValue: any) {
  //   formValue.type = 'incidentOwnersMapping';
  //   this.incidentOwnersMapping.emit(formValue);
  //   if (this.filteredDelete.length > 0) {
  //     this.filteredDelete.unshift('incidentOwnersMapping');
  //     this.deleteIncidentOwnersMappingEvent.emit(this.filteredDelete);
  //   }
  // }
  onSubmit(formValue: IncidentOwnerMappingDto[]) {
    this.incidentOwnersMapping.emit(formValue);
    if(this.filteredDelete.length !== 0) {
      this.deleteIncidentOwnersMappingEvent.emit(this.filteredDelete);
    }
    }
}
